// Auto-generated from ICSI2026_Program_Beijing.xlsx
const afternoonSessions = [
  {
    "name": "Onsite Room  (12 talks)",
    "items": [
      {
        "type": "talk",
        "time": "14:00-14:20",
        "paperId": "9702",
        "domain": "Swarm Intelligence Optimization Methods",
        "presenter": "Qidong Chen",
        "title": "Crystal Structure Prediction of High-entropy perovskite oxides via a Hybrid Energy-Entropy Collaborative Optimization Algorithm",
        "mode": "Onsite",
        "country": "China",
        "localTime": ""
      },
      {
        "type": "talk",
        "time": "14:20-14:40",
        "paperId": "6316",
        "domain": "Swarm Intelligence Optimization Methods",
        "presenter": "Anupam Sharma",
        "title": "Hybrid Swarm Intelligence for Path Planning of Unmanned Combat Air Vehicle Using Three-Point Threat Modeling",
        "mode": "Onsite",
        "country": "India",
        "localTime": ""
      },
      {
        "type": "talk",
        "time": "14:40-15:00",
        "paperId": "3318",
        "domain": "Particle Swarm Optimization",
        "presenter": "Xinfang Ji",
        "title": "Particle Swarm Optimizer Integrating Deep Belief Network and Surrogate Model for High-dimensional Expensive Optimization Problems",
        "mode": "Onsite",
        "country": "China",
        "localTime": ""
      },
      {
        "type": "talk",
        "time": "15:00-15:20",
        "paperId": "1208",
        "domain": "Multi-Objective Optimization",
        "presenter": "Xiang Fang",
        "title": "From Solution-Level to Structure-Level Transfer: Evolutionary Multitasking for Sparse Large-Scale Multiobjective Optimization",
        "mode": "Onsite",
        "country": "China",
        "localTime": ""
      },
      {
        "type": "talk",
        "time": "15:20-15:40",
        "paperId": "2501",
        "domain": "Multi-Objective Optimization",
        "presenter": "Xinxin Song",
        "title": "An Improved Multi-objective Particle Swarm Optimization Algorithm for Feature Selection",
        "mode": "Onsite",
        "country": "China",
        "localTime": ""
      },
      {
        "type": "talk",
        "time": "15:40-16:00",
        "paperId": "3382",
        "domain": "Machine Learning",
        "presenter": "Yihan Zhang",
        "title": "D-SACSL: Dual-Space Semantic Anchor-guided Continual Self-Supervised Learning",
        "mode": "Onsite",
        "country": "China",
        "localTime": ""
      },
      {
        "type": "break",
        "label": "☕  Tea Break  (16:00-16:20)  —  Onsite Room"
      },
      {
        "type": "talk",
        "time": "16:20-16:40",
        "paperId": "4949",
        "domain": "Machine Learning",
        "presenter": "Ben Niu",
        "title": "Machine Learning Models for Predicting Outpatient Waiting Time in Maternal and Child Healthcare: A Comparative Study",
        "mode": "Onsite",
        "country": "China",
        "localTime": ""
      },
      {
        "type": "talk",
        "time": "16:40-17:00",
        "paperId": "9105",
        "domain": "AI Agent, Multi-Agent System and Embodied AI",
        "presenter": "Yang Shen",
        "title": "An Empirical Study of Multi-Agent Collaboration for Automated Research",
        "mode": "Onsite",
        "country": "Australia",
        "localTime": ""
      },
      {
        "type": "talk",
        "time": "17:00-17:20",
        "paperId": "6030",
        "domain": "AI Agent, Multi-Agent System and Embodied AI",
        "presenter": "Wenhui Rui",
        "title": "A General Framework for Semi-Automatic Annotation Based on 3D-2D Geometry-Semantic Consistency for Embodied AI",
        "mode": "Onsite",
        "country": "China",
        "localTime": ""
      },
      {
        "type": "talk",
        "time": "17:20-17:40",
        "paperId": "3146",
        "domain": "AI Agent, Multi-Agent System and Embodied AI",
        "presenter": "Feng Liu",
        "title": "From Physical Observer to AI Agent: A First-Principles Derivation of the Minimal Complete Architecture",
        "mode": "Onsite",
        "country": "China",
        "localTime": ""
      },
      {
        "type": "talk",
        "time": "17:40-18:00",
        "paperId": "6404",
        "domain": "Various Optimization Applications",
        "presenter": "Tianwei Zhou",
        "title": "GNN-Pricing: Accelerating Column Generation for Graph Coloring via Group Relative Policy Optimization",
        "mode": "Onsite",
        "country": "China",
        "localTime": ""
      },
      {
        "type": "talk",
        "time": "18:00-18:20",
        "paperId": "1823",
        "domain": "Various Optimization Applications",
        "presenter": "Kangyi Wang",
        "title": "XPUShare: A Containerized Cluster GPU Sharing Framework for Closed-Source CUDA-Like Heterogeneous Platforms",
        "mode": "Onsite",
        "country": "China",
        "localTime": ""
      }
    ]
  },
  {
    "name": "Online Room 1  (16 talks)",
    "items": [
      {
        "type": "talk",
        "time": "13:00-13:20",
        "paperId": "8508",
        "domain": "Machine Learning",
        "presenter": "Paola Patricia Ariza Colpas",
        "title": "An Intelligent Decision Support System for Precision Agriculture Based on IoT and Machine Learning in Smallholder Cassava Farming",
        "mode": "Online",
        "country": "Colombia",
        "localTime": "00:00"
      },
      {
        "type": "talk",
        "time": "13:20-13:40",
        "paperId": "5633",
        "domain": "Machine Learning",
        "presenter": "Paola Patricia Ariza Colpas",
        "title": "A Reproducible IoT-Based Machine Learning Benchmark for Predicting Agronomic Variables in Smallholder Cassava Farming",
        "mode": "Online",
        "country": "Colombia",
        "localTime": "00:20"
      },
      {
        "type": "talk",
        "time": "13:40-14:00",
        "paperId": "3944",
        "domain": "AI Agent, Multi-Agent System and Embodied AI",
        "presenter": "Paola Patricia Ariza Colpas",
        "title": "A Socio-Technical Innovation Model for the Adoption of Industry 4.0 Technologies in Smallholder Agricultural Communities in the Colombian Caribbean",
        "mode": "Online",
        "country": "Colombia",
        "localTime": "00:40"
      },
      {
        "type": "talk",
        "time": "14:00-14:20",
        "paperId": "7000",
        "domain": "Various Optimization Applications",
        "presenter": "Paola Patricia Ariza Colpas",
        "title": "An IoT-Based Intelligent Architecture for Precision Agriculture in Smallholder Cassava Farming: A Case Study in the Colombian Caribbean",
        "mode": "Online",
        "country": "Colombia",
        "localTime": "01:00"
      },
      {
        "type": "talk",
        "time": "14:20-14:40",
        "paperId": "3227",
        "domain": "Particle Swarm Optimization",
        "presenter": "PRINCY VERMA",
        "title": "PSO-XAI-M: A Hybrid Approach to Assess the Significant Features for Maternal Mental Well-Being",
        "mode": "Online",
        "country": "India",
        "localTime": "11:50"
      },
      {
        "type": "break",
        "label": "☕  Tea Break  (14:40-15:00)  —  Online Room 1"
      },
      {
        "type": "talk",
        "time": "15:00-15:20",
        "paperId": "4496",
        "domain": "Machine Learning",
        "presenter": "Deepak Yadav",
        "title": "Optimizing mechanical ventilation strategies in critical care through deep reinforcement learning",
        "mode": "Online",
        "country": "India",
        "localTime": "12:30"
      },
      {
        "type": "talk",
        "time": "15:20-15:40",
        "paperId": "8404",
        "domain": "Multi-Objective Optimization",
        "presenter": "Frederick Kin Hing Phoa",
        "title": "A Perturbation-Based Spectral Variable Grouping Strategy for Large-Scale Multi-Objective Optimization",
        "mode": "Online",
        "country": "Taiwan (China)",
        "localTime": "15:20"
      },
      {
        "type": "talk",
        "time": "15:40-16:00",
        "paperId": "2508",
        "domain": "Optimization Methods for Applications",
        "presenter": "Jifu Hu",
        "title": "Aerodynamic Shape Optimization of a Ducted Fan Based on a Dynamic Surrogate Model and Differential Evolution",
        "mode": "Online",
        "country": "China",
        "localTime": "15:40"
      },
      {
        "type": "talk",
        "time": "16:00-16:20",
        "paperId": "6339",
        "domain": "AI Agent, Multi-Agent System and Embodied AI",
        "presenter": "Zhe Guo",
        "title": "An Agent-Driven Adaptive Ensemble Learning with Transformer-LNN for Financial Time Series Forecasting",
        "mode": "Online",
        "country": "China",
        "localTime": "16:00"
      },
      {
        "type": "talk",
        "time": "16:20-16:40",
        "paperId": "6409",
        "domain": "Scheduling and Task Allocation",
        "presenter": "Yuzhou Chen",
        "title": "Cooperative Scheduling of Fire Trucks and Fire Barrier Trucks in High-Intensity Forest Fires",
        "mode": "Online",
        "country": "China",
        "localTime": "16:20"
      },
      {
        "type": "talk",
        "time": "16:40-17:00",
        "paperId": "1275",
        "domain": "Swarm Intelligence Optimization Methods",
        "presenter": "Yang Cao",
        "title": "Improving Competitive Swarm Optimizer via Adaptive Spiral Search Mechanism",
        "mode": "Online",
        "country": "Japan",
        "localTime": "17:40"
      },
      {
        "type": "talk",
        "time": "17:00-17:20",
        "paperId": "1321",
        "domain": "Particle Swarm Optimization",
        "presenter": "Han Yang",
        "title": "Swarm Intelligence in Networked Environments: Disentangling Cooperative Synergy and Competitive Pressure with Endogenous Selection",
        "mode": "Online",
        "country": "China",
        "localTime": "17:00"
      },
      {
        "type": "talk",
        "time": "17:20-17:40",
        "paperId": "4922",
        "domain": "Machine Learning",
        "presenter": "Jiaxin Tian",
        "title": "Enhancing the Resilience of Highway Systems Considering Multi-Layer Energy Supply Networks",
        "mode": "Online",
        "country": "China",
        "localTime": "17:20"
      },
      {
        "type": "talk",
        "time": "17:40-18:00",
        "paperId": "6794",
        "domain": "Scheduling and Task Allocation",
        "presenter": "Hongwei Chen",
        "title": "A Distributed Adaptive Coverage Search Method for Multi-UAV Based on Local Communication",
        "mode": "Online",
        "country": "China",
        "localTime": "17:40"
      },
      {
        "type": "talk",
        "time": "18:00-18:20",
        "paperId": "436",
        "domain": "Scheduling and Task Allocation",
        "presenter": "Hanshu Chen",
        "title": "A Robust Trajectory-Tracking Controller for a Ribbon-Like Magnetic Microswarm",
        "mode": "Online",
        "country": "China",
        "localTime": "18:00"
      },
      {
        "type": "talk",
        "time": "18:20-18:40",
        "paperId": "7590",
        "domain": "Swarm Intelligence Optimization Methods",
        "presenter": "Jiuxiang Ma",
        "title": "Research on Critical Node Set Mining in Complex Networks Based on Genetic Algorithm",
        "mode": "Online",
        "country": "China",
        "localTime": "18:20"
      }
    ]
  },
  {
    "name": "Online Room 2  (15 talks)",
    "items": [
      {
        "type": "talk",
        "time": "13:00-13:20",
        "paperId": "980",
        "domain": "Optimization Methods for Applications",
        "presenter": "Rodrigo Colnago Contreras",
        "title": "A Hybrid QANA with Massive Local Search for the Pseudo-Coloring Problem",
        "mode": "Online",
        "country": "Brazil",
        "localTime": "02:00"
      },
      {
        "type": "talk",
        "time": "13:20-13:40",
        "paperId": "2796",
        "domain": "Particle Swarm Optimization",
        "presenter": "Sayanika Paul",
        "title": "Stability-guided Particle Swarm Optimization with Second-Order Velocity Motion Analysis",
        "mode": "Online",
        "country": "India",
        "localTime": "10:50"
      },
      {
        "type": "talk",
        "time": "13:40-14:00",
        "paperId": "6095",
        "domain": "Particle Swarm Optimization",
        "presenter": "Zhiyuan Xin",
        "title": "Research on Improved Particle Swarm Optimization Algorithm for Calculation of Metasurface Equivalent Circuit Model",
        "mode": "Online",
        "country": "China",
        "localTime": "13:40"
      },
      {
        "type": "talk",
        "time": "14:00-14:20",
        "paperId": "4939",
        "domain": "Machine Learning",
        "presenter": "Zhihong Li",
        "title": "Graph-Temporal Kolmogorov-Arnold Networks and Nested Ensemble Learning for Financial Fraud Detection",
        "mode": "Online",
        "country": "China",
        "localTime": "14:00"
      },
      {
        "type": "talk",
        "time": "14:20-14:40",
        "paperId": "1509",
        "domain": "Multi-Objective Optimization",
        "presenter": "Guoqiang Wu",
        "title": "A Two-Stage Space-Transformation Algorithm for High-Dimensional Multi-Objective Feature Selection",
        "mode": "Online",
        "country": "China",
        "localTime": "14:20"
      },
      {
        "type": "break",
        "label": "☕  Tea Break  (14:40-15:00)  —  Online Room 2"
      },
      {
        "type": "talk",
        "time": "15:00-15:20",
        "paperId": "2191",
        "domain": "LLM-based Heuristics Approaches",
        "presenter": "Xiaoqian Zhu",
        "title": "Large Language Model-Based Health Policy Evaluation: A Novel Decision Support Paradigm",
        "mode": "Online",
        "country": "China",
        "localTime": "15:20"
      },
      {
        "type": "talk",
        "time": "15:20-15:40",
        "paperId": "5690",
        "domain": "Swarm Intelligence Optimization Methods",
        "presenter": "Vivekanand Pandey",
        "title": "HRL-VACO: Vehicle-First Optimization for VRPTW using Hierarchical Learning and Ant Colony Optimization",
        "mode": "Online",
        "country": "India",
        "localTime": "13:10"
      },
      {
        "type": "talk",
        "time": "15:40-16:00",
        "paperId": "5604",
        "domain": "Swarm Intelligence Optimization Methods",
        "presenter": "Jean-Pierre van Zyl",
        "title": "A Multi-Swarm Set-based Particle Swarm Optimisation Approach to Finding Minimal Reducts",
        "mode": "Online",
        "country": "South Africa",
        "localTime": "10:00"
      },
      {
        "type": "talk",
        "time": "16:00-16:20",
        "paperId": "8570",
        "domain": "AI Agent, Multi-Agent System and Embodied AI",
        "presenter": "Kaijian Zhang",
        "title": "LLM-Driven Micro-Behavior Simulation: Managing Agent Adaptability via Dynamic Goal Stacks",
        "mode": "Online",
        "country": "China",
        "localTime": "16:20"
      },
      {
        "type": "talk",
        "time": "16:20-16:40",
        "paperId": "6198",
        "domain": "LLM-based Heuristics Approaches",
        "presenter": "Ashish Kumar",
        "title": "LLM-based Swarm-Cooperative Hyper-Heuristics for Vehicle Routing",
        "mode": "Online",
        "country": "India",
        "localTime": "14:10"
      },
      {
        "type": "talk",
        "time": "16:40-17:00",
        "paperId": "8791",
        "domain": "LLM-based Heuristics Approaches",
        "presenter": "Ju Liu",
        "title": "ReAct-RAG for Chest X-Ray Report Generation",
        "mode": "Online",
        "country": "China",
        "localTime": "17:00"
      },
      {
        "type": "talk",
        "time": "17:00-17:20",
        "paperId": "5429",
        "domain": "Scheduling and Task Allocation",
        "presenter": "Gengsong Li",
        "title": "Multi-objective Preferred Strategy-Based Ant Lion Optimizer for UAV Swarm Task Allocation in Uncertain Environments",
        "mode": "Online",
        "country": "China",
        "localTime": "17:20"
      },
      {
        "type": "talk",
        "time": "17:20-17:40",
        "paperId": "4222",
        "domain": "Scheduling and Task Allocation",
        "presenter": "Tianping Hou",
        "title": "Underwater Dual-arm Synchronous Control Based on Cross Coupling Strategy and Model Predictive Control",
        "mode": "Online",
        "country": "China",
        "localTime": "17:40"
      },
      {
        "type": "talk",
        "time": "17:40-18:00",
        "paperId": "1456",
        "domain": "Optimization Methods for Applications",
        "presenter": "Quansheng Dou",
        "title": "Kinetics-Guided Convolutional Kernel Optimization for Adsorption-Desorption Electronic Nose Data",
        "mode": "Online",
        "country": "China",
        "localTime": "18:00"
      },
      {
        "type": "talk",
        "time": "18:00-18:20",
        "paperId": "4718",
        "domain": "Scheduling and Task Allocation",
        "presenter": "Shengkai Li",
        "title": "Adaptive Swarms, Failures, and Cancer",
        "mode": "Online",
        "country": "China",
        "localTime": "18:20"
      },
      {
        "type": "talk",
        "time": "18:20-18:40",
        "paperId": "9103",
        "domain": "Optimization Methods for Applications",
        "presenter": "JIACHENG LI",
        "title": "An Enhanced INS-WOA for Static Evacuation Route Optimization under Disaster Conditions",
        "mode": "Online",
        "country": "Japan",
        "localTime": ""
      }
    ]
  }
];

export default afternoonSessions;
